import { MasterAPIService } from "@app/services/Methods/api";

export const getStations = () => MasterAPIService.get("/station");
